jQuery(document).ready(function ($) {

	/* Close subcrible mobile */
	var subcribleMobile = getCookie('subcribleMobile');
	if (subcribleMobile) {
		$('.subcrible-mobile').hide();
	}
	$('.subcrible-mobile .popup__close').click(function () {
		$('.subcrible-mobile').hide();
		setCookie('subcribleMobile', 1, 2)
	});


	function setCookie(name, value, days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	}
	function getCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}
	function eraseCookie(name) {
		document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	}
	function validateEmail(email) {
		var re = /\S+@\S+\.\S+/;
		return re.test(email);
	};
	let myIntervalCount = 0;
	const myInterval = setInterval(function () {
		myIntervalCount++;
		if (myIntervalCount > 1200) clearInterval(myInterval);
		else if ($('#insta-feed a img').length) {

			$('#insta-feed').addClass('owl-carousel');
			$('#insta-feed').owlCarousel({
				items: 3,
				nav: false,
				dots: false,
				margin: 0,
				responsive: {
					0: {
						items: 1
					},
					480: {
						items: 2
					},
					768: {
						items: 3
					},
					1024: {
						items: 4
					},
					1280: {
						items: 5
					}
				}
			});

			clearInterval(myInterval);
		}
	}, 500);

	if ($('.home.recent-box').length) {
		$('.home.recent-box .button--add-to-cart.sold-out').click(function () {
			$(this).hide().closest('.product-item').find('.product__notify-form').show();
			return false;
		})
		$('.home.recent-box .list-product .product-item .product-name').matchHeight();
		$('.home.recent-box .list-product').addClass('owl-carousel');
		$('.home.recent-box .list-product').owlCarousel({
			items: 4,
			nav: false,
			dots: false,
			margin: 0,
			responsive: {
				0: {
					items: 1,
					nav: true,
					loop: true
				},
				480: {
					items: 2,
					nav: true,
					loop: true
				},
				768: {
					items: 3,
					nav: true
				},
				1024: {
					items: 4
				}
			}
		});
		jQuery(document).click(function (e) {
			var container = jQuery(".home.recent-box .list-product .product-item .status .product__notify-form");
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				container.hide();
				$('.home.recent-box .list-product .product-item .status button').show();
			}
		});

		let notify_product_ids = getCookie('notify-product-ids');
		if (notify_product_ids) {
			$('.home.recent-box .notify_form').each(function () {
				if (notify_product_ids.includes($(this).find('.product-id').text())) {
					$(this).find('.notify-form__success-message').html(Shopify.translation.notify_form_success);
					$(this).find('.contact-form').addClass('hide');
				}
			})
		}
		$('.home.recent-box .notify_form .action_button').click(function () {
			let form = $(this).closest('form');
			let email = form.find('[name="contact[email]"]').val()
			let old_ids = getCookie('notify-product-ids');
			let id = form.find('.product-id').text();
			if (validateEmail(email)) {
				if (old_ids) {
					if (!old_ids.includes(id)) {
						setCookie('notify-product-ids', old_ids + ',' + id, 30);
					}
				} else {
					setCookie('notify-product-ids', id, 30);
				}
			}
		});
	}

	$('.home-development-box .heading a').click(function () {
		jQuery('body, html').animate({
			scrollTop: jQuery('#rating-section').offset().top,
		});
	});
	$('.mobile-menu .mobile-menu__list .mobile-menu__list-item').click(function () {
		$(this).parents('.mobile-menu--opened #mobile-header .mobile-menu').addClass('none-login');
	});

	$('.home-explore-box .toggle-tab').click(function () {
		$('.home-explore-box .toggle-tab').children('span').text('See Inside');
		if (!$(this).hasClass('showing')) {
			$('.home-explore-box .toggle-tab').removeClass('showing');
			$(this).addClass('showing');
			$(this).children('span').text('Close');
		} else {
			$(this).removeClass('showing');
			$(this).children('span').text('See Inside');
		}

		var id = $(this).attr('data-open');
		$('.home-explore-box .tab-label.' + id).toggleClass('active');
		$('.home-explore-box .tab-content[id="' + id + '"]').toggleClass('active');
		$(this).parents('.tab-label').siblings('.tab-label').removeClass('active');
		$(this).closest('.explore-tabs').find('.tab-content:not([id="' + id + '"])').removeClass('active');
		//      	var link = $(this).closest('.home-explore-box .explore-tabs').find(' .tab-content.active .product-area ul li img').attr('src');
		//       		console.log(link)
		//       	$('.home-explore-box .explore-tabs .tab-content.active .product-area>img').attr('src', link);
		setThumbExploreH();
	})
	function setThumbExploreH() {
		if ($('.home-explore-box .tab-content.active .product-area ul').length) {
			console.log('object ', $('.home-explore-box .tab-content.active .product-area .full-image').height())
			$('.home-explore-box .tab-content.active .product-area ul').css('max-height', $('.home-explore-box .tab-content.active .product-area .full-image').height());
		}
	}

	$('body').on('click', '.home-explore-box .explore-tabs .tab-content.active .product-area ul li', function () {
		var img_url = $(this).find('img').attr('src');
		$('.home-explore-box .explore-tabs .tab-content.active .product-area ul li').removeClass('active');
		$(this).addClass('active');
		$(this).closest('.content-wrapper').find('.full-image').attr('src', img_url);
	})
	// $('.home-explore-box .explore-tabs .tab-content .product-area ul').owlCarousel({
	// 	items: 5,
	// 	nav: false,
	// 	dots: false,
	// 	margin: 0
	// })
	//$('.box-slide').addClass('owl-carousel');
	$('.box-slide .image,.box-slide .content').owlCarousel({
		items: 1,
		nav: true,
		dots: false,
		touchDrag: false,
		mouseDrag: false,
		margin: 30,
		responsive: {
			0: {
				margin: 5
			},
			768: {
				margin: 10
			}
		}
	});

	$('.home-explore-box .explore-tabs .tab-labels').addClass('owl-carousel');
	var exploreTabLabels = $('.home-explore-box .explore-tabs .tab-labels');
	exploreTabLabels.owlCarousel({
		items: 3,
		nav: false,
		dots: false,
		margin: 0,
		responsive: {
			0: {
				items: 1,
				nav: true
			},
			568: {
				items: 2,
				nav: true
			},
			1024: {
				items: 3
			}
		}
	});
	exploreTabLabels.on('changed.owl.carousel', function () {
		$('.home-explore-box .toggle-tab').removeClass('showing');
		$('.home-explore-box .toggle-tab').children('span').text('See Inside');
		$('.home-explore-box .tab-label, .home-explore-box .tab-content').removeClass('active');
	})


	$('.home.home-development-box .icon-wrapper .box-icon-wraper').addClass('owl-carousel');
	$('.home.home-development-box .icon-wrapper .box-icon-wraper').owlCarousel({
		items: 3,
		nav: false,
		dots: false,
		margin: 0,
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			1280: {
				items: 3
			}
		}
	});

	$('.box-slide .image .owl-prev').click(function () {
		$('.box-slide .content').trigger('prev.owl.carousel');
	});

	$('.box-slide .image .owl-next').click(function () {
		$('.box-slide .content').trigger('next.owl.carousel');
	});


	setTimeout(function () {
		if ($(window).width() < 640) {
			$('.yotpo-reviews-carousel .carousel-display-wrapper .yotpo-carousel .single-carousel').css('width', $('.home.rating-box .yotpo-reviews-carousel .carousel-display-wrapper .scroller').width() + 'px');
		} else if ($(window).width() < 1000) {
			$('.yotpo-reviews-carousel .carousel-display-wrapper .yotpo-carousel .single-carousel').css('width', $('.home.rating-box .yotpo-reviews-carousel .carousel-display-wrapper .scroller').width() / 2 + 'px');
		}
	}, 2000)
	var resizeFun;
	$(window).on('resize', function () {
		clearTimeout(resizeFun);
		resizeFun = setTimeout(function () {
			productHeight();
			setThumbExploreH();
			if ($(window).width() < 640) {
				$('.yotpo-reviews-carousel .carousel-display-wrapper .yotpo-carousel .single-carousel').css('width', $('.home.rating-box .yotpo-reviews-carousel .carousel-display-wrapper .scroller').width() + 'px');
			} else if ($(window).width() < 1000) {
				$('.yotpo-reviews-carousel .carousel-display-wrapper .yotpo-carousel .single-carousel').css('width', $('.home.rating-box .yotpo-reviews-carousel .carousel-display-wrapper .scroller').width() / 2 + 'px');
			} else {
				$('.yotpo-reviews-carousel .carousel-display-wrapper .yotpo-carousel .single-carousel').css('width', '');
			}
		}, 300);
	})
	productHeight();
	function productHeight() {
		if ($('.related-products .products-slider .gallery-cell .product-thumbnail .title-product').length) {
			$('.related-products .products-slider .gallery-cell .product-thumbnail .title-product').matchHeight();
		}
	};
	/* Home Rating */
	$('.home.rating-box .rating-feature').owlCarousel({
		items: 2,
		nav: false,
		dots: false,
		margin: 0,
		responsive: {
			0: {
				items: 1,
				nav: true
			},
			767: {
				items: 1,
				nav: true
			},
			768: {
				items: 1,
				nav: false
			},
			1199: {
				items: 1,
				nav: false
			},
			1200: {
				items: 2,
				nav: false
			}
		}
	});

})